import React from 'react';
import { Box } from '@mui/material';
import { useTileDimensions } from './hooks/useTileDimensions';
import { MainPhotoDropZone } from './MainPhotoDropZone';

interface DragPlaceholderProps {
  isShowDescriptions: boolean;
  isSmallDisplay: boolean;
  isOverMainPosition: boolean;
}

export const DragPlaceholder: React.FC<DragPlaceholderProps> = ({
  isShowDescriptions,
  isSmallDisplay,
  isOverMainPosition,
}) => {
  const { tileHeight, tileWidth, tileMarginX, tileMarginY } =
    useTileDimensions(isShowDescriptions);
  if (isOverMainPosition) {
    return (
      <MainPhotoDropZone
        isVisible={true}
        isShowDescriptions={isShowDescriptions}
      />
    );
  } else {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          width: tileWidth,
          maxWidth: tileWidth,
          height: `${tileHeight}px`,
          flexGrow: isSmallDisplay ? 1 : 0,
          border: '2px dashed',
          borderColor: 'grey.400',
          borderRadius: 2,
          backgroundColor: 'grey.100',
          mx: `${tileMarginX}px`,
          my: `${tileMarginY}px`,
          opacity: 0.5,
        }}
      />
    );
  }
};
